import React, { useState } from 'react';
import { Modal, Form, Input, Select, Button, notification } from 'antd';
import { HITECH_API, getAuthHeaders } from './api';

const CreateUser = ({ open, onClose, onCreated }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await fetch(`${HITECH_API}/admin/users`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(values),
      });
      const data = await res.json();
      if (data.success) {
        notification.success({ message: `User "${values.name}" created successfully` });
        form.resetFields();
        onCreated && onCreated(data.user);
        onClose();
      } else {
        notification.error({ message: data.message || 'Failed to create user' });
      }
    } catch {
      notification.error({ message: 'Network error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={<span style={{ color: '#0d2e61', fontWeight: 700 }}>Create New User</span>}
      footer={null}
      width={520}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onFinish} style={{ marginTop: 16 }}>
        <Form.Item
          name="name"
          label="Full Name"
          rules={[{ required: true, message: 'Name is required' }]}
        >
          <Input placeholder="Enter full name" size="large" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email Address"
          rules={[
            { required: true, message: 'Email is required' },
            { type: 'email', message: 'Enter a valid email' },
          ]}
        >
          <Input placeholder="Enter email address" size="large" />
        </Form.Item>

        <Form.Item name="mobile" label="Mobile Number">
          <Input placeholder="10-digit mobile number" size="large" maxLength={10} />
        </Form.Item>

        <Form.Item name="password" label="Password">
          <Input.Password placeholder="Leave blank to auto-generate" size="large" />
        </Form.Item>

        <Form.Item
          name="role"
          label="Role"
          initialValue="user"
          rules={[{ required: true }]}
        >
          <Select size="large">
            <Select.Option value="user">User</Select.Option>
            <Select.Option value="moderator">Moderator (Admin Access)</Select.Option>
          </Select>
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ background: '#0d2e61', borderColor: '#0d2e61' }}
          >
            Create User
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default CreateUser;
